import React from "react";
import styles from "../styles/Thank-you.module.css";
import HeroSection from "../components/HeroSection";
import OfferBanner from "../components/OfferBanner";
import PricingSection from "../components/PricingSection";
import FAQSection from "../components/FAQSection";


const ThankYouPage: React.FC = () => {
  return (
    <div className={styles.container}>
      <HeroSection />
      <OfferBanner />
      <PricingSection />
      <FAQSection />
    </div>
  );
};

export default ThankYouPage;
